// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__A43N-","Image":"Card_Image__K3I-w","Content":"Card_Content__PbxwO","Date":"Card_Date__MiFSj"};